// extracted by mini-css-extract-plugin
module.exports = {"sikkaBtn":"styles_sikkaBtn__JkSZ0","gradient":"styles_gradient__pdlPB","proBtn":"styles_proBtn__DkvHA"};